// extracted by mini-css-extract-plugin
module.exports = {"main":"TopicTitle_main__1JQZ8","online":"TopicTitle_online__5D2-L","title":"TopicTitle_title__1Jnps"};